




















































import * as analyticHelper from '@/lib/analytic-helper';
import {
  Component,
  Prop,
  Vue,
  Provide,
  Watch,
  Emit,
  Inject,
} from 'vue-property-decorator';
import { FundSearchState, FundHistoryState } from '../../store';
import { ILookupResult, IMenuItem } from '../../store/shared-types';
import { namespace } from 'vuex-class';
import AxSpinner from '../AxSpinner/AxSpinner.vue';

const fundSearchStore = namespace('FundSearchState');
const fundHistoryStore = namespace('FundHistoryState');

interface IEntityResult {
  entityType: string;
  name: string;
  code: string;
  entityUrl: string;
}

@Component({
  name: 'EntityResultsPanel',
  components: {
    AxSpinner
  },
})
export default class EntityResultsPanel extends Vue {
  @Prop({ required: false }) public caption: string;
  @Prop({ required: false }) public mode: 'search' | 'history';
  @Prop({ required: false }) public show: boolean;
  @fundHistoryStore.Getter('items') historyItems: ILookupResult[];
  @fundHistoryStore.Getter('selectedResultIndex') historySelectedIndex: number;
  @fundHistoryStore.Getter('selectedResult') historySelectedResult: ILookupResult | null;

  @fundSearchStore.Getter('lastFetchError') lastSearchFetchError: string | null;
  @fundSearchStore.Getter('numberOfFetching') numberOfSearchFetching: number;
  @fundSearchStore.Getter('results') searchItems: ILookupResult[];
  @fundSearchStore.Getter('selectedResultIndex') searchSelectedIndex: number;
  @fundSearchStore.Getter('selectedResult') searchSelectedResult: ILookupResult | null;

  @fundHistoryStore.Action('add') addItemToHistory: (item: ILookupResult) => void;
  @fundHistoryStore.Action('selectNextResult') historyDown: () => void;
  @fundHistoryStore.Action('selectPreviousResult') historyUp: () => void;
  @fundHistoryStore.Action('load') loadHistory: () => void;

  @fundSearchStore.Action('lookup') search: (text: string) => void;
  @fundSearchStore.Action('selectNextResult') searchDown: () => void;
  @fundSearchStore.Action('selectPreviousResult') searchUp: () => void;

  @Inject('searchText') public searchTextInjector: () => string;
  public get searchText() {
    return this.searchTextInjector();
  }
  @Watch('searchText')
  onSearchText(value: string, oldValue: string) {
    if (this.mode === 'history') {return;}
    if (!this.show) {return;}
    this.search(value);
  }
  @Watch('show')
  onShow(value: boolean, oldValue: boolean) {
    if (this.mode === 'history') {return;}
    if (!value) {return;}
    this.search(this.searchText);
  }
  @Emit('navigate') public navigate(e: Event) { return e; }
  public get selectedResult(): ILookupResult | null {
    if (this.mode === 'search') {
      return this.searchSelectedResult;
    }
    if (this.mode === 'history') {
      return this.historySelectedResult;
    }
    return null;
  }
  public get selectedIndex(): number {
    if (this.mode === 'search') {
      return this.searchSelectedIndex;
    }
    if (this.mode === 'history') {
      return this.historySelectedIndex;
    }
    return 0;
  }
  public get isFetching(): boolean {
    if (this.mode === 'search') {
      return this.numberOfSearchFetching > 0;
    }
    if (this.mode === 'history') {
      return false;
    }
    return false;
  }
  public get showFetchError(): boolean {
    if (this.mode === 'search') {
      return !!this.lastSearchFetchError;
    }
    if (this.mode === 'history') {
      return false;
    }
    return false;
  }
  public get lastFetchError(): string {
    return this.lastSearchFetchError || '';
  }
  public get items(): ILookupResult[] {
    if (this.mode === 'search') {
      return this.searchItems;
    }
    if (this.mode === 'history') {
      return this.historyItems;
    }
    return [];
  }
  public beforeCreate() {
    FundSearchState.register?.(this.$store);
    FundHistoryState.register?.(this.$store);
  }
  public beforeMount() {
    const parentVueNode = this.$parent?.$parent;
    if (parentVueNode?.$el?.classList?.contains('ax-searchbar')) {
      parentVueNode.$off('onUpKeyPressedInSearchbox', this.onUpKeyPressedInSearchbox);
      parentVueNode.$off('onDownKeyPressedInSearchbox', this.onDownKeyPressedInSearchbox);
      parentVueNode.$off('actionOnSelectedItem', this.actionOnSelectedItem);
      parentVueNode.$on('onUpKeyPressedInSearchbox', this.onUpKeyPressedInSearchbox);
      parentVueNode.$on('onDownKeyPressedInSearchbox', this.onDownKeyPressedInSearchbox);
      parentVueNode.$on('actionOnSelectedItem', this.actionOnSelectedItem);
    }
    this.loadHistory();
  }
  public beforeUnmount() {
    const parentVueNode = this.$parent?.$parent;
    if (parentVueNode?.$el?.classList?.contains('ax-searchbar')) {
      parentVueNode.$off('onUpKeyPressedInSearchbox', this.onUpKeyPressedInSearchbox);
      parentVueNode.$off('onDownKeyPressedInSearchbox', this.onDownKeyPressedInSearchbox);
      parentVueNode.$off('actionOnSelectedItem', this.actionOnSelectedItem);
    }
  }
  public onUpKeyPressedInSearchbox() {
    if (!this.show) {return;}
    if (this.mode === 'history') {this.historyUp();}
    if (this.mode === 'search') {this.searchUp();}
  }
  public onDownKeyPressedInSearchbox() {
    if (!this.show) {return;}
    if (this.mode === 'history') {this.historyDown();}
    if (this.mode === 'search') {this.searchDown();}
  }
  public actionOnSelectedItem() {
    if (!this.show) {return;}
    const selectedResult = this.selectedResult;
    if (!selectedResult) {return;}
    analyticHelper.powerbarSearchItemActivatedEvent({
      label: selectedResult.label,
      target: selectedResult.target,
      href: selectedResult.href,
      modal: selectedResult.modal,
    });
    if (selectedResult.modal) {
      const anchor = document.createElement('A') as HTMLAnchorElement;
      anchor.href = selectedResult.href;
      anchor.target = selectedResult.target;
      anchor.classList.add('sip-modal', 'sip-link');
      const that = this;
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        that.navigate(e);
      });
      anchor.click();
    } else {
      const { href, target } = selectedResult;
      window.open(href, target);
    }
  }
  public destroyed() {
    FundSearchState.unregister?.(this.$store);
    FundHistoryState.unregister?.(this.$store);
  }
  public itemClassForIndex(index: number) {
    return { selected: index === this.selectedIndex };
  }
  public simpleHighlight(text: string) {
    return text?.replace(
      new RegExp(this.searchText, 'gi'),
      match => `<span style="background-color: rgba(255,255,255,0.2);">${match}</span>`);
  }
  public itemLabelHtml(item: ILookupResult) {
    return this.simpleHighlight(item.label);
  }
  public itemSublabelHtml(item: ILookupResult) {
    return this.simpleHighlight(item.sublabel);
  }
  navigateAction(e: Event, item: ILookupResult) {
    const target = e.target as Element;
    if (target?.classList?.contains('ax-icon--pop-out') ||
      target?.parentElement?.classList?.contains('popout')) {
      return;
    }
    this.addItemToHistory(item);
    analyticHelper.powerbarSearchItemActivatedEvent({
      label: item.label,
      target: item.target || '',
      href: item.href,
      modal: item.modal,
    });
    this.navigate(e);
    window.open(item.href, '_self');
  }
  navigateActionBlank(e: Event, item: ILookupResult) {
    this.addItemToHistory(item);
    analyticHelper.powerbarSearchItemActivatedEvent({
      label: item.label,
      target: item.target || '',
      href: item.href,
      modal: item.modal,
    });
    e.stopPropagation();
    window.open(item.href, '_blank');
  }
  public iconColorForResult(item: ILookupResult): string {
     const {entityType , fullEntityType} = item;

     if (entityType?.toLowerCase() === 'p' && fullEntityType?.toLowerCase() === 'partnership') {
      return `background-color: var(--class-rose); color: inherit;`;
    }
    if (entityType?.toLowerCase() === 'p' && fullEntityType?.toLowerCase() === 'personal') {
      return `background-color: var(--int-warm-grey-tint-75); color: inherit;`;
    }
    if (entityType?.toLowerCase() === 's' && fullEntityType?.toLowerCase() === 'smsf') {
      return `background-color: var(--int-teal-tint-75); color: inherit;`;
    }
    if (entityType?.toLowerCase() === 's' && fullEntityType?.toLowerCase() === 'saf') {
      return `background-color: var(--int-warm-grey-tint-20); color: var(--int-dark-grey);`;
    }
    if (entityType?.toLowerCase() === 't' && fullEntityType?.toLowerCase() === 'trust') {
      return `background-color: var(--class-amethyst); color: inherit;`;
    }
    if (entityType?.toLowerCase() === 'c' && fullEntityType?.toLowerCase() === 'company') {
      return `background-color: var(--class-grape); color: inherit;`;
    }
    if (entityType?.toLowerCase() === 'c' && fullEntityType?.toLowerCase() === 'consolidated') {
      return `background-color: var(--int-teal-tint-30); color: var(--int-dark-grey);`;
    }
    return `background-color: var(--int-warm-grey); color: inherit;`; // default color
  }
}
